import type { ProductKey } from "@/lib/billing/entitlements";
import { routePurchase, type PlanSubscription, type PurchaseRoute } from "@/lib/billing/purchase-route";
import {
  DIAMOND_MONTHLY_PRICE_ID,
  GOLD_MONTHLY_PRICE_ID,
  SILVER_MONTHLY_PRICE_ID,
} from "@/lib/billing/tier-price-ids";

const GATE_PRICE_ID: Record<ProductKey, string> = {
  "ev-plan": SILVER_MONTHLY_PRICE_ID,
  "whale-watch": GOLD_MONTHLY_PRICE_ID,
  "ev-sniper": DIAMOND_MONTHLY_PRICE_ID,
};

export function normalizeProductTypeParam(raw: string | null): ProductKey | null {
  if (!raw) return null;
  const normalized = raw.trim().toLowerCase();
  if (
    normalized === "ev-plan" ||
    normalized === "+ev optimizer" ||
    normalized === "+ev plan" ||
    normalized === "ev optimizer"
  ) {
    return "ev-plan";
  }
  if (normalized === "whale-watch" || normalized === "whale watch") {
    return "whale-watch";
  }
  if (
    normalized === "ev-sniper" ||
    normalized === "+ev sniper" ||
    normalized === "ev sniper" ||
    normalized === "sniper"
  ) {
    return "ev-sniper";
  }
  return null;
}

export function featureGateRoute(
  subscriptions: readonly PlanSubscription[],
  product: ProductKey,
): PurchaseRoute {
  return routePurchase(subscriptions, { priceId: GATE_PRICE_ID[product], interval: "month" });
}
